import React from 'react';
import './AboutUs.scss';
import ShowAboutUs from '../Admin/ShowAboutUs';
import Loader from '../Loader/Loader';
import { Link } from 'react-router-dom';

const AboutUs = () => {

    const { aboutus, load, err, fetchaboutus } = ShowAboutUs();

    if (load) {
        return <div className="loader"><Loader /></div>;
    }

    if (err) {
        return <div className="error">Error: {err.message}</div>;
    }

    return (
        <section id='aboutussection'>
            <div class="breadcrumb">
                <Link to='/'>Home</Link> &gt; <a href="#">About Us</a>
            </div>
            <div className="about-us-container">
                <div className="about-us-header">
                    <h1>About Us</h1>
                </div>
                <div className="about-us-content">
                    <p dangerouslySetInnerHTML={{ __html: aboutus.about_us }} />
                </div>
            </div>
        </section>
    )
}

export default AboutUs